import React, { Component } from "react";
import { SearchField, SearchButton } from "@sainsburys-tech/luna-react";
import { connect } from "react-redux";
import {
  setRangeIdFilter,
  setCurrentRangeIdInputValue,
  disableDropdowns,
} from "../../../store/imagelibraryfilters/actions";

class RangeIdFilter extends Component {
  constructor(props) {
    super(props);
    this.searchRangeIdData = this.searchRangeIdData.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.state = {
      disableSearchBtn: true,
    };
    this.numbersAllowedRegex = /^[0-9]*$/;
  }

  searchRangeIdData(e) {
    e.preventDefault();
    this.props.dispatch(setRangeIdFilter(this.props.currentRangeIdInputValue));
    this.props.dispatch(disableDropdowns(true));
  }

  handleInputChange(e) {
    e.preventDefault();
    const newValue = e.target.value;

    if (newValue && this.numbersAllowedRegex.test(newValue)) {
      this.setState({ disableSearchBtn: false });
      this.props.dispatch(setCurrentRangeIdInputValue(newValue));
    } else {
      this.setState({ disableSearchBtn: true });
      this.props.dispatch(setCurrentRangeIdInputValue(newValue));
    }
  }

  render() {
    return (
      <SearchField
        name="rangeIdnumber-searchfield"
        label="Range Id"
        hasButton
        value={this.props.currentRangeIdInputValue}
        onChange={this.handleInputChange}
        button={
          <SearchButton
            onClick={(e) => this.searchRangeIdData(e)}
            disabled={this.state.disableSearchBtn}
          />
        }
      />
    );
  }
}

export default connect((state, props) => {
  return {
    options: state.imageLibraryData.dropdownValues.rangeIds || [],
    currentRangeIdInputValue:
      state.imageLibraryData.currentRangeIdInputValue || "",
    rangeIdFilter: state.imageLibraryData.rangeIdFilter || "",
  };
})(RangeIdFilter);
